import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SET_AGENTS, SET_AGENT, SET_AGENT_CLIENTS, SET_AGENT_ACCESS_RIGHTS } from "./agent-mutations";
import { agentSchema } from "./agent-schema";
import { getAgents, getAgent, getAgentClients, updateAgent, inviteAgent, updateAgentAccessRights } from "../api/agents-api";
import { normalize } from "normalizr";
import { getClientsByAgent } from "@Broker/@Modules/clients/applications/application/api/applications-list-api";
import Err from "@Broker/@Routes/error";
export const LOAD_AGENTS = "LOAD_AGENTS";
export const LOAD_AGENT = "LOAD_AGENT";
export const LOAD_AGENT_CLIENTS = "LOAD_AGENT_CLIENTS";
export const UPDATE_AGENT = "UPDATE_AGENT";
export const INVITE_AGENT = "INVITE_AGENT";
export const SORT_AGENT_CLIENTS = "SORT_AGENT_CLIENTS";
export const UPDATE_AGENT_ACCESS_RIGHTS = "UPDATE_AGENT_ACCESS_RIGHTS";
const actions = {
  [LOAD_AGENTS]: async (context, {
    withClients
  } = {
    withClients: false
  }) => {
    try {
      const brokers = await getAgents({
        withClients
      });
      const {
        entities,
        result
      } = normalize(brokers, [agentSchema]);
      context.commit(SET_AGENTS, {
        byId: entities.agents || {},
        allIds: result
      });
    } catch (e) {
      Err.handle(e, {});
    }
  },
  [LOAD_AGENT]: async (context, agentUsername) => {
    try {
      const agent = await getAgent(agentUsername);
      context.commit(SET_AGENT, _objectSpread(_objectSpread({}, agent), {}, {
        username: agentUsername
      }));
    } catch (e) {
      Err.handle(e, {});
    }
  },
  [LOAD_AGENT_CLIENTS]: async (context, agentUsername) => {
    try {
      const {
        clients
      } = await getAgentClients(agentUsername);
      context.commit(SET_AGENT_CLIENTS, {
        agentUsername,
        clients
      });
    } catch (e) {
      Err.handle(e, {}, "failedToLoadClients");
    }
  },
  [UPDATE_AGENT]: async (context, {
    details,
    agentUsername
  }) => {
    try {
      await updateAgent(details, agentUsername);
      context.commit(SET_AGENT, _objectSpread(_objectSpread({}, details), {}, {
        username: agentUsername
      }));
    } catch (e) {
      Err.handle(e, {}, "failedToUpdateAgent");
      throw e;
    }
  },
  [INVITE_AGENT]: async (context, {
    details
  }) => {
    return await inviteAgent(details);
  },
  [SORT_AGENT_CLIENTS]: async (context, {
    agentUsername,
    orderBy,
    orderType
  }) => {
    try {
      const {
        clients
      } = await getClientsByAgent({
        agentUsername,
        orderBy,
        orderType
      });
      context.commit(SET_AGENT_CLIENTS, {
        agentUsername,
        clients
      });
    } catch (e) {
      Err.handle(e, {}, "failedToLoadClients");
    }
  },
  [UPDATE_AGENT_ACCESS_RIGHTS]: async (context, {
    agentUsername,
    accessRights
  }) => {
    try {
      await updateAgentAccessRights(agentUsername, accessRights);
      context.commit(SET_AGENT_ACCESS_RIGHTS, {
        agentUsername,
        accessRights
      });
      const currentAccountUsername = context.rootGetters["AccountStore/CURRENT_USER_USERNAME"];
      if (agentUsername === currentAccountUsername) {
        var _accessRights$viewOnl;
        context.commit("AccountStore/SET_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY", {
          viewOnly: (_accessRights$viewOnl = accessRights.viewOnly) != null ? _accessRights$viewOnl : false
        }, {
          root: true
        });
      }
    } catch (e) {
      Err.handle(e, {}, "failedToUpdateAgentAccessRights");
      throw e;
    }
  }
};
export default actions;